export const SET_ALBARANES = "SET_ALBARANES";
export const SET_CAMIONES = "SET_CAMIONES";
export const SET_OBRAS = "SET_OBRAS";
export const SET_TIPOS = "SET_TIPOS";
export const SET_VERTEDEROS = "SET_VERTEDEROS";

export const SET_ALBARAN_PENDIENTE = "SET_ALBARAN_PENDIENTE";
